import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1.7 7.04v-4.8l4.2 2.469L1.7 7.04zM8.898 4.04h14.4v1.2h-14.4zM1.699 11.84h21.6v1.2h-21.6zM1.699 19.64h21.6v1.2h-21.6z" fill="#000" /></svg>;